import { ChainConfigEntry } from './chain/types'

export const paths = {
  home: '/',
  easyBorrow: '/borrow',
  borrow: '/borrow',
  dashboardPooled: '/dashboard/pooled',
  dashboardIsolated: '/dashboard/isolated',
  dashboardLendBorrow: '/dashboard/lend-borrow',
  dashboardEarn: '/dashboard/earn',
  activity: '/dashboard/activity',
  marketsEBorrow: '/borrow/explore',
  swap: '/swap',
  trade: '/trade',
  bridge: '/bridge',
  bridgeHyperCore: '/bridge/hyper-core',
  pooledDetails: '/markets/pooled/:chainId/:asset',
  isolatedDetails: '/markets/isolated/:chainId/:pairAddress',
  eLendDetails: '/markets/elend/:chainId/:vaultAddress',
  eBorrowDetails: '/markets/eborrow/:collateral/:liability',
  usdxl: '/usdxl',
  earn: '/earn',
  earnAssets: '/earn/assets',
  earnVaults: '/earn/vaults',
  opportunities: '/opportunities',
  points: '/points',
  lendDetails: '/lend/:chainId/:vaultAddress',
  deprecatedVaultDetails: '/usdxl/vaults/:chainId/:vaultAddress',
  privacyPolicy: '/privacy-policy',
  termsOfService: '/terms-of-service',
  card: '/card',
  cardTelegramNotifications: '/card/telegram-notifications',
} as const

export type Path = keyof typeof paths

export const pathGroups = {
  home: ['home'],
  borrow: ['borrow', 'easyBorrow', 'dashboardPooled', 'pooledDetails'],
  isolated: ['isolatedDetails', 'dashboardIsolated'],
  elend: ['eLendDetails'],
  eborrow: ['marketsEBorrow', 'eBorrowDetails'],
  lend: ['earn', 'earnAssets', 'earnVaults', 'lendDetails', 'dashboardEarn'],
  opportunities: ['opportunities'],
  points: ['points'],
  usdxl: ['usdxl', 'deprecatedVaultDetails'],
  card: ['card', 'cardTelegramNotifications'],
  bridge: ['bridge', 'bridgeHyperCore'],
  swap: ['swap'],
  trade: ['trade'],
  activity: ['activity'],
  privacyPolicy: ['privacyPolicy'],
  termsOfService: ['termsOfService'],
} satisfies Record<
  | 'home'
  | 'borrow'
  | 'isolated'
  | 'elend'
  | 'eborrow'
  | 'lend'
  | 'opportunities'
  | 'points'
  | 'usdxl'
  | 'card'
  | 'bridge'
  | 'swap'
  | 'trade'
  | 'activity'
  | 'privacyPolicy'
  | 'termsOfService',
  Path[]
>

export function getSupportedPages(chainConfigEntry: ChainConfigEntry): Path[] {
  return [
    ...pathGroups.home,
    ...(chainConfigEntry?.markets ? pathGroups.borrow : []),
    ...pathGroups.lend,
    ...pathGroups.opportunities,
    ...pathGroups.points,
    ...pathGroups.isolated,
    ...pathGroups.elend,
    ...pathGroups.eborrow,
    ...pathGroups.usdxl,
    ...pathGroups.card,
    ...pathGroups.bridge,
    ...pathGroups.swap,
    ...pathGroups.trade,
    ...pathGroups.activity,
    ...pathGroups.privacyPolicy,
    ...pathGroups.termsOfService,
  ]
}
